<template>
  <div class="vcv-progress" :class="[`vcv-progress--${color}`]">
    <div class="vcv-progress__value" :style="{ width: value + '%' }"></div>

    <div class="vcv-progress__test">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VcvProgress',

  props: {
    value: {
      type: Number,
      default: 0
    },

    color: {
      type: String,
      default: 'green'
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/fonts.scss';

.vcv-progress {
  width: 100%;
  padding: 3px 10px;
  border-radius: 3px;
  overflow: hidden;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  &__value {
    background: lighten($green-light, 10%);
    position: absolute;
    height: 100%;
    border-radius: 3px;
    top: 0;
    left: 0;
    bottom: 0;
  }

  &__test {
    text-align: center;
    position: relative;
    z-index: 1;
    @include mixin-text-main;
  }

  &--green {
    background: $green-normal;

    .vcv-progress__value {
      background: lighten($green-light, 10%);
    }
  }

  &--red {
    background: lighten($red-lighter, 10%);

    .vcv-progress__value {
      background: $red-lighter;
    }
  }

  &--orange {
    background: lighten($orange-light, 20%);

    .vcv-progress__value {
      background: lighten($orange-light, 10%);
    }
  }
}
</style>
